import isEmpty from 'lodash/isEmpty';

import { Details, Mol } from '../types';
import { MoleculeError } from './customErrors';

export function draw(
  mol: Mol,
  qmol?: Mol,
  canvas?: HTMLCanvasElement,
  details: Details = {},
  width: number = 0,
  height: number = 0,
  offsetx: number = 0,
  offsety: number = 0
): string {
  let res;
  if (!mol.is_valid()) {
    mol.delete();
    qmol?.delete();
    throw new MoleculeError('SMILES not valid');
  }

  if (qmol != null) {
    if (!qmol.is_valid()) {
      mol.delete();
      qmol?.delete();
      throw new MoleculeError('SMARTS not valid');
    } else {
      let mdetails = {
        ...details,
        ...JSON.parse(mol.get_substruct_match(qmol)),
      };

      if (mdetails.atoms == null || !mdetails.atoms.length) {
        throw new MoleculeError('No atoms');
      }

      res =
        canvas != null
          ? mol.draw_to_canvas_with_highlights(
              canvas,
              JSON.stringify(mdetails),
              width,
              height,
              offsetx,
              offsety
            )
          : mol.get_svg_with_highlights(
              JSON.stringify(mdetails),
              width,
              height,
              offsetx,
              offsety
            );
    }
  } else if (!isEmpty(details)) {
    res =
      canvas != null
        ? mol.draw_to_canvas_with_highlights(
            canvas,
            JSON.stringify(details),
            width,
            height,
            offsetx,
            offsety
          )
        : mol.get_svg_with_highlights(
            JSON.stringify(details),
            width,
            height,
            offsetx,
            offsety
          );
  } else {
    res =
      canvas != null
        ? mol.draw_to_canvas(canvas, width, height, offsetx, offsety)
        : mol.get_svg(width, height, offsetx, offsety);
  }

  mol.delete();
  qmol?.delete();

  return res;
}
